import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { StatsBand } from './components/StatsBand';
import { DifferenceSection } from './components/DifferenceSection';
import { ComparisonSection } from './components/ComparisonSection';
import { PainPointsSection } from './components/PainPointsSection';
import { LevelsSection } from './components/LevelsSection';
import { MapAnatomySection } from './components/MapAnatomySection';
import { ProgressionSection } from './components/ProgressionSection';
import { BonusSection } from './components/BonusSection';
import { PracticeSection } from './components/PracticeSection';
import { SamplesSection } from './components/SamplesSection';
import { BonusPackSection } from './components/BonusPackSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
interface AppProps {
  showCountdownBar?: boolean;
  samplesLayout?: 'carousel' | 'grid';
}
export function App({
  showCountdownBar = true,
  samplesLayout = 'carousel'
}: AppProps) {
  React.useEffect(() => {
    const name = 'facebook-domain-verification';
    const content = 'prolx231v7pi554iedwsy1x0w8nc3c';
    let tag = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('name', name);
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', content);
  }, []);
  return <div className="min-h-screen w-full bg-cream font-sans" data-id="element-0" data-mp="3diry6xarslch">
      {showCountdownBar ? <UrgencyBar data-id="element-1" data-mp="nvaq9mxor7e0" /> : null}
      <Hero data-id="element-2" data-mp="suncc5gqgafj" />
      <main data-id="element-3" data-mp="sudmqizlo5ad">
        <StatsBand data-id="element-4" data-mp="stue5svuat90" />
        <DifferenceSection data-id="element-5" data-mp="stc864jdl0nw" />
        <ComparisonSection data-id="element-6" data-mp="swqd9kjfbnz1" />
        <PainPointsSection data-id="element-7" data-mp="3684hdq2uasw" />
        <LevelsSection data-id="element-8" data-mp="35glr3hkw7k1" />
        <MapAnatomySection data-id="element-9" data-mp="34x4zq3nzp7l" />
        <ProgressionSection data-id="element-10" data-mp="38b2ajxh1886" />
        <BonusSection data-id="element-11" data-mp="3udazyhcy738x" />
        <PracticeSection data-id="element-12" data-mp="3ubzumd3utnfp" />
        <SamplesSection layout={samplesLayout} data-id="element-13" data-mp="3uevs60bsia3m" />
        <BonusPackSection data-id="element-14" data-mp="d4xobc1ja5bs" />
        <OfferSection data-id="element-15" data-mp="d45rxz0443kg" />
        <GuaranteeSection data-id="element-16" data-mp="d2l7j27ii10b" />
        <TestimonialsSection data-id="element-17" data-mp="85ujnspgu14c" />
        <FaqSection data-id="element-18" data-mp="86mgf6usu4w7" />
        <FinalCtaSection data-id="element-19" data-mp="86cnpbiddjmt" />
      </main>
      <Footer data-id="element-20" data-mp="3gl4srkrrw6lm" />
    </div>;
}